import { faCat, faDog, faPaw, faPen, faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppointmentPet } from '@spike/appointment-model';
import { PetTypeIds } from '@spike/model';
import React from 'react';
import { useReportBuilder } from '../ReportBuilderProvider';
import styles from './ReportHeader.module.scss';

const PetAvatarInlineComponent: React.FC<{ pet: AppointmentPet }> = ({ pet }) => {
    const { petAvatar, hasCustomPetAvatar, setPetAvatar, removePetAvatar } = useReportBuilder();
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const icon = pet.type?.id === PetTypeIds.CATS ? faCat : pet.type?.id === PetTypeIds.DOGS ? faDog : faPaw;

    const fileChangeHandler = React.useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const file = event.target.files?.[0];

            if (!file) {
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                if (typeof reader.result === 'string') {
                    setPetAvatar(reader.result, file);
                }
            };
            reader.readAsDataURL(file);

            // Allow re-selecting the same file
            event.target.value = '';
        },
        [setPetAvatar]
    );

    const editClickHandler = React.useCallback(() => fileInputRef.current?.click(), []);

    return (
        <div className={styles.avatarWrapper}>
            <div className={styles.avatar}>
                {petAvatar ? (
                    <img
                        src={petAvatar}
                        alt={pet.name}
                    />
                ) : (
                    <FontAwesomeIcon icon={icon} />
                )}
            </div>
            <button
                type="button"
                className={styles.avatarEditButton}
                onClick={editClickHandler}
                aria-label="Change pet image"
            >
                <FontAwesomeIcon icon={faPen} />
            </button>
            {hasCustomPetAvatar && (
                <button
                    type="button"
                    className={styles.avatarRemoveButton}
                    onClick={removePetAvatar}
                    aria-label="Remove pet image"
                >
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            )}
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                className={styles.avatarFileInput}
                onChange={fileChangeHandler}
            />
        </div>
    );
};

export const PetAvatarInline = React.memo(PetAvatarInlineComponent);
